class ShopTheLookTabs extends HTMLElement {
    constructor() {
        super();

        this.tabs = this.querySelectorAll('[data-tab-target]');
        this.tabContents = this.querySelectorAll('[data-tab-content]');

        this.switchTab();
    }

    switchTab() {
        const self = this;
        const tabs = self.tabs;
        const tabContents = self.tabContents;

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const target = document.querySelector(tab.dataset.tabTarget);
                
                tabContents.forEach(tabContent => tabContent.classList.remove('active'));
                tabs.forEach(tab => tab.classList.remove('active'));
                
                tab.classList.add('active');
                target.classList.add('active');
            })
        })
    }
}

customElements.define('shop-the-look-tabs', ShopTheLookTabs);
